import { FromObservable } from './FromObservable';
export const from = FromObservable.create;
//# sourceMappingURL=from.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs-es/observable/from.js
// module id = 92
// module chunks = 4